import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TUserResolve } from '../../types/currentUser';

const initialState = null as TUserResolve;

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<TUserResolve>) => {
      return action.payload;
    },
  },
});

export const {
  reducer: userReducer,
  actions: { setUser },
} = userSlice;
